@if (formState) {
    <mnm-form [state]="formState" [translateLabels]="true" [noContainer]="true">
        <div class="mt-2 text-center">
            <button
                type="submit"
                class="btn btn-lg btn-primary me-2"
                (click)="submit()"
                [disabled]="isSubmitting"
            >
                @if (isSubmitting) {
                    <app-loading-ring class="me-2"></app-loading-ring>
                }
                <i class="fa-light fa-save me-2"></i>
                <span>{{ 'translate_save' | translate }}</span>
            </button>
            <button
                type="button"
                class="btn btn-lg btn-outline-white"
                (click)="cancel()"
                [disabled]="isSubmitting"
            >
                <i class="fa-light fa-times me-2"></i>
                <span>{{ 'translate_cancel' | translate }}</span>
            </button>
        </div>
    </mnm-form>
}
